import { ColdStoragePage } from './ColdStoragePage'

export const BlastFreezerPage = () => <ColdStoragePage mode="blastFreezer" />
export default ColdStoragePage
